import React from 'react'
import styleNotification from './Notification.module.scss'
import { NotificationViewProps } from './useNotification'

export const NotificationView = (props: NotificationViewProps): JSX.Element => {
  const { notifications, myClassNames } = props

  return (
    <div className={styleNotification._}>
      {notifications.length > 0
        ? (
            notifications.map((notification, index) => (
              <div className={styleNotification._block} key={index}>
                <span className={
                  styleNotification._short + ' ' +
                  (notification.close ? myClassNames(notification) + ' ' + styleNotification._short_close : myClassNames(notification))}>
                  {notification.close ? (<div className={styleNotification._exit} />) : null}
                  {notification.message}
                </span>
              </div>
            ))
          )
        : null}
    </div>
  )
}
